module.exports = __webpack_public_path__ + "img/beer-mug-empty.dd9159a2.svg";